import React from 'react'
import { Flex } from 'reflexbox'

import { useCurrentRequest, useKeyValueObject } from 'utils/hooks'
import { Project } from 'lib/project'
import { DataTable, DataTableField, IconButton } from '@rapidapi/ui-lib'
import { RequestTabViewProps } from 'ecosystems/project/request-editor/request-tabs/request-tabs-props.d'
import { DynamicStringEditor } from 'ecosystems/field-editors'
import { TabBoxContainer } from 'ecosystems/http-exchange-viewer/http-exchange-tabs'
import useChangeOrder from 'store/hooks/use-change-order.hook'
import useAddKeyValue from 'store/hooks/use-add-key-value.hook'
import useDeleteKeyValue from 'store/hooks/use-delete-key-value.hook'
import useChangeItemData from 'store/hooks/use-change-item-data.hook'

const fields: DataTableField<Project.KeyValue>[] = [
  {
    key: 'Header Name',
    value: (data) =>
      (data?.name && (
        <DynamicStringEditor
          dynamicStringRef={data.name}
          placeholder="Add Header Name"
          autocompleteCategory="LMCompletionCategoryHTTPRequestHeaders"
          hover
        />
      )) ??
      '',
  },
  {
    key: 'Header Value',
    value: (data) =>
      (data?.value && (
        <DynamicStringEditor
          dynamicStringRef={data.value}
          placeholder="Add Value"
          autocompleteCategory="LMCompletionCategoryHTTPRequestHeadersValue"
          hover
        />
      )) ??
      '',
  },
]

const useItemDataSelectorList = (
  item: Project.GenericRef<Project.KeyValue>,
) => {
  const data = useKeyValueObject(item)

  return {
    uuid: data.uuid,
    data,
    disabled: false,
    checked: data.enabled,
  }
}

const RequestHeadersTab: React.FC<RequestTabViewProps> = () => {
  const request = useCurrentRequest()
  const dataTableItems = request?.headers.map((data) => ({
    uuid: data.ref,
    data,
  }))

  // updates the enabled/disabled status
  const onChangeItemData = useChangeItemData()

  // adds a new item at the end of the table
  const addNewKeyValue = useAddKeyValue(
    { ref: request ? request.uuid : '' },
    'headers',
  )

  // deletes an item
  const deleteKeyValue = useDeleteKeyValue(
    { ref: request ? request.uuid : '' },
    'headers',
  )

  // changes items order
  const onChangeOrder = useChangeOrder<Project.Request>(
    { ref: request ? request.uuid : '' },
    'headers',
  )

  return (
    <TabBoxContainer p={5} scrollable>
      <Flex flexDirection="column">
        <DataTable
          fields={fields}
          items={dataTableItems ?? []}
          itemDataSelector={useItemDataSelectorList}
          onChangeItemData={onChangeItemData}
          endAdornment={(item) => (
            <IconButton
              icon="close"
              size="small"
              type="button"
              onClick={() => deleteKeyValue(item.uuid)}
            />
          )}
          onChangeOrder={onChangeOrder}
          lastRow={{
            placeholders: ['Add Header Name', 'Add Value'],
            onClick: addNewKeyValue,
          }}
          reorderable
          hasCheckbox
        />
      </Flex>
    </TabBoxContainer>
  )
}

export default RequestHeadersTab
